<template>
  <div class="contract-use-file">
    <h3 style="margin-bottom:30px">平台使用教程</h3>
    <div class="item">
      <h4>第一步：创建合约模板</h4>
      <img class="image" src="@/assets/images/contractReleaseProcess/创建合约模板.jpg" alt />
    </div>
    <div class="item">
      <h4>第二步：保存合约模板</h4>
      <h5>1. 通过sol文件保存模板</h5>
      <img class="image" src="@/assets/images/contractReleaseProcess/源代码发布.jpg" alt />
      <h5>2. 通过abijson保存模板</h5>
      <img class="image" src="@/assets/images/contractReleaseProcess/abi发布.jpg" alt />
       <h5>3. 通过合约编辑器保存模板</h5>
      <img class="image" src="@/assets/images/contractReleaseProcess/合约编辑器发布.jpg" alt />
    </div>
    <div class="item">
      <h4>第三步：发布合约</h4>
      <img class="image" src="@/assets/images/contractReleaseProcess/合约发布.jpg" alt />
    </div>
    <div class="item">
      <h4>第四步：合约发布结果查询</h4>
      <img class="image" src="@/assets/images/contractReleaseProcess/合约发布结果查询.jpg" alt />
    </div>
    <div class="item">
      <h4>第五步：合约调用</h4>
      <img class="image" src="@/assets/images/contractReleaseProcess/合约调用.jpg" alt />
    </div>
    <div class="item">
      <h4>第六步：合约交易</h4>
      <img class="image" src="@/assets/images/contractReleaseProcess/合约交易.jpg" alt />
    </div>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.contract-use-file {
  padding-left: 30px;
  padding-top: 10px;
  .item {
    margin-bottom: 30px;
    .image {
      width: 800px;
    }
  }
}
</style>